<template>
	<AppTable :fetch-function="fetchLogs"
			  :filters="filters"
			  :table-headings="tableHeadings"
			  :title="tableTitle"
			  :total-items="totalLogRows"
			  :items="logs"
			  initial-sort-field="date">
	</AppTable>
</template>

<script>
import AppTable from "@/shared/components/AppTable.vue";
import {useLanguageStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import API from "@/shared/helpers/API";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";

export default {
	setup() {
		let userStore = useUserStore();
		return {getString: useLanguageStore().getString, userStore};
	},
	name: "WebhookLog",
	emits: ['fetch-error'],
	components: {AppChevronIcon, AppTable},
	data() {
		return {
			tableHeadings: [
				{
					text: this.getString('date'),
					cols: 1,
					fieldName: 'date',
					sortable: true
				},
				{
					text: this.getString('webhook_type'),
					cols: 1,
					fieldName: 'event_type',
					sortable: true
				},
				{
					text: this.getString('duration'),
					cols: 1,
					fieldName: 'execution_time_s',
					sortable: true
				},
				{
					text: this.getString('code'),
					cols: 1,
					fieldName: 'response_code',
					sortable: false
				},
				{
					text: this.getString('response'),
					cols: 3,
					fieldName: 'response',
					sortable: false
				},
			],
			filters: [
				{
					type: "date",
					key: 'date',
					tableName: 'businesses_webhooks_logs',
					text: this.getString('date'),
					finalValue: '',
					active: false
				},
				{
					type: "checklist",
					key: "event_type",
					text: this.getString("webhook_type"),
					active: false,
					values: [this.getString('orders.new'),this.getString("orders.update")],
					keysArray: ['orders.new','orders.update'],
					selectedIndexes: [],
					callbackValue: (v, filterIndex) => {
						const filter = this.filters[filterIndex];
						filter.selectedIndexes = v;
						filter.active = !!filter.selectedIndexes.length;

						let returningText = "";
						if (filter.active) {
							filter.selectedIndexes.forEach(selectedIndex => {
								returningText += returningText ? ", " : "";
								returningText += filter.values[selectedIndex];
							});
						}
						filter.finalValue = returningText;
					}
				}
			],
			logs: [],
			totalLogRows: 0,
			offset: 0
		}
	},
	props: {
		webhook: {
			type: Object,
			default: null
		}
	},
	methods: {
		fetchLogs(filters, callback = null) {
			if(!this.userStore.currBusinessId) { return []; }

			API.init().getWebhookLog(
				this.userStore.currBusinessId,
				this.webhook.webhook_id,
				filters,
				res => {
					if(res.result === 'OK') {
						this.logs = [];
						res.data.selected.forEach(item => {
							this.logs.push(this.normalizeLog(item));
						});
						this.totalLogRows = parseInt(res.data.selected_num);
						if(callback) { callback(true); }
					}
					else {
						this.$emit('fetch-error');
						if(callback) { callback(false, res ? res.details : null); }
					}
				}
			);
		},
		normalizeLog(item) {
			return {
				date: item.date,
				execution_time_s: item.execution_time_s,
				response_code: item.response_code,
				response: item.response,
				event_type: this.getString(item.event_type),
			}
		}
	},
	computed: {
		tableTitle() {
			return this.getString('webhook_log',[this.webhook ? this.webhook.title : '']);
		},
	}
}
</script>

<style scoped lang="scss">
</style>